// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3t8yKVlNW4UXF7 {\n  padding: 4px 8px 4px 12px;\n}\n._18O6R-d4BJp2-P {\n  display: flex;\n}\n._1EIduqCLN_iD41 {\n  margin-top: 4px;\n  max-width: 230px;\n}\n.w6CkIi_9-1xviK {\n  font-size: 9pt;\n  color: #B3BAC5;\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 230px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accountAvatar": "_3t8yKVlNW4UXF7",
	"accountItem": "_18O6R-d4BJp2-P",
	"accountName": "_1EIduqCLN_iD41",
	"accountEmail": "w6CkIi_9-1xviK"
};
export default ___CSS_LOADER_EXPORT___;
